import React from 'react';
import { LockIcon, CheckCircleIcon, ShieldCheckIcon } from 'lucide-react';
import { trackInitiateCheckout, trackLead } from '../../utils/metaPixel';
interface CTAButtonProps {
  text?: string;
  href?: string;
  showAllTrust?: boolean;
  className?: string;
}
export function CTAButton({
  text = 'Acceder hoy',
  href = '#pago',
  showAllTrust = false,
  className = ''
}: CTAButtonProps) {
  const handleClick = () => {
    if (href.includes('hotmart')) {
      trackInitiateCheckout();
    } else {
      trackLead();
    }
  };
  return <div className={`flex flex-col items-center w-full ${className}`} data-id="element-60">
      <a href={href} className="cta-button" onClick={handleClick} data-id="element-61">
        {text}
      </a>

      {showAllTrust ? <div className="flex items-center justify-center lg:justify-start gap-4 mt-4 text-xs text-gray-500 font-medium w-full max-w-[400px]" data-id="element-62">
          <span className="flex items-center" data-id="element-63">
            <LockIcon className="w-3 h-3 text-brand-gold mr-1.5" data-id="element-64" /> Compra
            Segura
          </span>
          <span className="flex items-center" data-id="element-65">
            <CheckCircleIcon className="w-3 h-3 text-brand-gold mr-1.5" data-id="element-66" />{' '}
            Garantía 7 Días
          </span>
          <span className="flex items-center" data-id="element-67">
            <ShieldCheckIcon className="w-3 h-3 text-brand-gold mr-1.5" data-id="element-68" />{' '}
            Privacidad
          </span>
        </div> : <div className="flex items-center justify-center gap-4 mt-4 text-xs text-gray-500 font-medium" data-id="element-69">
          <span className="flex items-center" data-id="element-70">
            <LockIcon className="w-3 h-3 text-brand-gold mr-1.5" data-id="element-71" /> Compra
            Segura
          </span>
          <span className="flex items-center" data-id="element-72">
            <CheckCircleIcon className="w-3 h-3 text-brand-gold mr-1.5" data-id="element-73" />{' '}
            Garantía 7 Días
          </span>
        </div>}
    </div>;
}